import { CheckboxGroup } from 'components/admin/ui/Form/CheckboxGroup';
import { COUNTRY_BY_CODE } from 'lib/datasets/countries';
import { STATES_AND_TERRITORIES_BY_CODE } from 'lib/datasets/statesAndTerritories';
import { ILocation } from 'lib/types/user';
import _ from 'lodash';

interface ILocationsCheckboxGroupProps {
  locations: ILocation[];
  onChange: (value: string[]) => void;
  value: string[];
  disabled?: boolean;
}

export const LocationsCheckboxGroup = ({
  locations,
  onChange,
  value,
  disabled = false,
}: ILocationsCheckboxGroupProps) => {
  const states = _.filter(value, (l) => !COUNTRY_BY_CODE[l]);
  const countries = _.filter(value, (l) => !!COUNTRY_BY_CODE[l]);

  const handleCountriesChange = (value: string[]) => {
    onChange(_.concat(states, value));
  };

  const handleStatesChange = (value: string[]) => {
    onChange(_.concat(countries, value));
  };

  const countriesOptions = _.chain(locations)
    .map((l) => {
      return {
        label: COUNTRY_BY_CODE[l.country].name,
        value: l.country,
      };
    })
    .uniqBy((o) => o.value)
    .orderBy([(o) => o.value !== COUNTRY_BY_CODE.USA.code, (o) => o.label])
    .value();

  const showCountriesCheckboxGroup =
    countriesOptions.length > 1 ||
    countriesOptions[0]?.value !== COUNTRY_BY_CODE.USA.code;

  const statesOptions = _.chain(locations)
    .map((l) => {
      if (l.state) {
        return {
          label: STATES_AND_TERRITORIES_BY_CODE[l.state].name,
          value: `${l.country}_${l.state}`,
        };
      }
    })
    .compact()
    .sortBy((o) => o.label)
    .value();

  const showStatesCheckboxGroup = statesOptions.length > 0;

  return (
    <>
      {showCountriesCheckboxGroup && (
        <CheckboxGroup
          name="countries"
          onChange={handleCountriesChange}
          options={countriesOptions}
          title="Country"
          value={countries}
          disabled={disabled}
        />
      )}
      {showStatesCheckboxGroup && (
        <CheckboxGroup
          name="states"
          onChange={handleStatesChange}
          options={statesOptions}
          title="State"
          value={states}
          disabled={disabled}
        />
      )}
    </>
  );
};
